export default "__VITE_ASSET__DS_2_0f6__"